import { render } from "./BuscarUsuario.vue?vue&type=template&id=4c7c9d6d&ts=true"
import script from "./BuscarUsuario.vue?vue&type=script&lang=ts"
export * from "./BuscarUsuario.vue?vue&type=script&lang=ts"

import "./BuscarUsuario.vue?vue&type=style&index=0&id=4c7c9d6d&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__